import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button", "dropdown"]

  resetApplicableSection() {
    // 移除所有combo_offfer form裡面的object_keys
    const hiddenField = document.querySelector('#hidden-applicable-object-key');
    if (hiddenField) {
      const keyInputs = hiddenField.querySelectorAll('input');
      keyInputs.forEach((input) => {
        input.remove();
      });
    }

    // 移除下拉選單的所有選項
    while (this.dropdownTarget.firstChild) {
      this.dropdownTarget.firstChild.remove();
    }

    // 移除搜尋input的內容
    this.inputTarget.value = '';

    // 移除條列出來的applicable_items
    const applicableItems = document.querySelector('#applicable_items_table');
    if (applicableItems) {
      applicableItems.remove()
    }

    // 移除search form的hidden_fields
    const searchItemForm = document.querySelector('#search-item-form');
    if (applicableItems) {
      const Types = searchItemForm.querySelectorAll("input[type='hidden']");
      Types.forEach((type) => {
        type.remove();
      });
    }

    // 移除search form的hidden_fields
    const newItemForm = document.querySelector('#add-item-form');
    if (newItemForm) {
      const Types = newItemForm.querySelectorAll("input[type='hidden']");
      Types.forEach((type) => {
        type.remove();
      });
    }

    // 把顯示items的筆數歸零
    let itemsSizeSpan = document.getElementById("applicable_items_size")
    itemsSizeSpan.innerText = "共0筆"
  }

  updateLink(event) {
    const type = event.target.value;
    const example_link = document.getElementById('example-link');
    example_link.setAttribute('href', `/admin/promotions/download_example?download_example_type=${type}`)
  }

  updatePlaceholder(event) {
    const type = event.target.value;
    const placeholder = document.getElementById('applicable-item-search');

    switch (type) {
      case "book_list":
        placeholder.setAttribute('placeholder', '清單編號／清單名稱');
        break;
      case 'eslite_sn':
        placeholder.setAttribute('placeholder', '誠品26碼／品名關鍵字');
        break;
      case 'mch':
        placeholder.setAttribute('placeholder', 'MCH 3,4,6,9碼');
        break;
      case 'manufacturer':
        placeholder.setAttribute('placeholder', '出版社編號／名稱關鍵字');
        break;
      case 'supplier':
      placeholder.setAttribute('placeholder', '供應商編號／名稱關鍵字');
      break;
    }
  }

  // 獲取選擇的 radio button 的值
  getSelectedType() {
    let selectedType
    const radios = document.querySelectorAll('input[type="radio"][name="combo_offer[applicable_type]"]');
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedType = radio.value;
      }
    })

    return selectedType
  }

  indexAddHiddenField(event){
    let selectedType = this.getSelectedType()
    const form = this.element;
    let hiddenField = form.querySelector("input[type='hidden'][name='search_form_applicable_type']");
    if (hiddenField) {
      hiddenField.remove()
    }

    // 創建新的 hidden field，並將其添加到combo_offer form中
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "search_form_applicable_type";
    typeHiddenField.value = selectedType;
    event.target.appendChild(typeHiddenField);
  }

  addItem(event){
    let selectedType = this.getSelectedType()
    const form = this.element;

    // 產生一個適用item type的hidden field，並將其添加到form中
    const hiddenField = form.querySelector("input[type='hidden'][name='applicable_type']");

    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "applicable_type";
    typeHiddenField.value = selectedType;
    event.target.appendChild(typeHiddenField);

    const selectedOption = this.dropdownTarget.selectedOptions[0];
    if (selectedOption) {
        // 回傳已經存在畫面上的項目，讓api可以濾掉不重複顯示。
        let existedItems = document.querySelectorAll(".applicable_item_checkbox")
        var values = [];

        existedItems.forEach(function(item) {
          values.push(item.value);
        });
        let exsitedItemsField = document.createElement("input");
        exsitedItemsField.type = "hidden";
        exsitedItemsField.name = "exsisted_items";
        exsitedItemsField.value = values;
        event.target.appendChild(exsitedItemsField);

        // 判斷畫面上的items清單是否有顯示, 將結果送到api，render不同內容
        let table = document.getElementById('applicable_items_table');
        let targetDisplay;
        if (table) {
          targetDisplay = true;
        } else {
          targetDisplay = false;
        }
        let paramsHiddenField = document.createElement("input");
        paramsHiddenField.type = "hidden";
        paramsHiddenField.name = "target_display";
        paramsHiddenField.value = targetDisplay;
        event.target.appendChild(paramsHiddenField);

        // 因為要刪除已加入的下拉選項，避免送表單送出空值，要再加一個value送出
        let selectedValue = this.dropdownTarget.value;
        let selectedValueField = document.createElement("input");
        selectedValueField.type = "hidden";
        selectedValueField.name = "selected_value";
        selectedValueField.value = selectedValue;
        selectedOption.remove();
        event.target.appendChild(selectedValueField);
    }
  }

  uploadItems(event) {
    // 判斷畫面上的items清單是否有顯示, 將結果送到api，render不同內容
    let table = document.getElementById('applicable_items_table');
    let targetDisplay;
    if (table) {
      targetDisplay = true;
    } else {
      targetDisplay = false;
    }
    let targetDisplayField = document.createElement("input");
    targetDisplayField.type = "hidden";
    targetDisplayField.name = "target_display";
    targetDisplayField.value = targetDisplay;
    event.target.appendChild(targetDisplayField);

    // 因為跟下拉選單加入適用項目共用同一支api，這邊要讓api知道是上傳名功能，會做批次撈資料及顯示。
    let multiItemsField = document.createElement("input");
    multiItemsField.type = "hidden";
    multiItemsField.name = "multi_items";
    multiItemsField.value = true;
    event.target.appendChild(multiItemsField);

    // 需送目前user所選的適用項目類型，來判斷要搜尋什麼資料。
    // 產生一個適用item type的hidden field，並將其添加到form中
    let selectedType = this.getSelectedType()
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "applicable_type";
    typeHiddenField.value = selectedType;
    event.target.appendChild(typeHiddenField);

    // 如果要加入的選項已經在項目table裡面，api那邊會濾掉不撈重複的項目顯示在畫面上。
    let existedItems = document.querySelectorAll(".applicable_item_checkbox")
    var values = [];

    existedItems.forEach(function(item) {
      values.push(item.value);
    });

    let exsitedItemsField = document.createElement("input");
    exsitedItemsField.type = "hidden";
    exsitedItemsField.name = "exsisted_items";
    exsitedItemsField.value = values;
    event.target.appendChild(exsitedItemsField);
  }

  removeItem(event) {
    event.preventDefault();
    const itemTable = this.element.querySelector("#applicable_items_table");
    const checkboxes = this.element.querySelectorAll(".applicable_item_checkbox");
    const checkAll = this.element.querySelector("#applicable-check-all")
    if (checkboxes.length == 1 || checkAll.checked) {
      itemTable.remove()
    }
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const itemElement = checkbox.closest("tr");

        // 找到並刪除對應的 hidden input
        const itemValue = itemElement.dataset.value;

        const applicableKeys = document.getElementById('hidden-applicable-object-key');
        const hiddenInput = applicableKeys.querySelector(`input[value="${itemValue}"]`);

        if (hiddenInput) {
          hiddenInput.remove();
        }

        itemElement.remove();
      }
    });

    // 處理顯示的排除項目筆數
    // 現在顯示的筆數 - 勾選移除的筆數 = 新的筆數
    let itemsSizeSpan = document.getElementById("applicable_items_size")
    var checkedSize = 0;
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        checkedSize++;
      }
    }

    let newSize = checkboxes.length - checkedSize
    let newContent = itemsSizeSpan.innerText.replace(checkboxes.length, newSize)
    itemsSizeSpan.innerText = newContent
  }

  checkAll(event) {
    const checkboxes = document.querySelectorAll(".applicable_item_checkbox");
    checkboxes.forEach(checkbox => {
        checkbox.checked = event.target.checked;
    });
  }

  updateCheckAll(event) {
    if (!event.target.checked && checkAll.checked) {
      const checkAll = this.element.querySelector("#applicable-check-all")
      checkAll.checked = false
    }
  }
}
